class ProgressEvent {

	// commands

	get ADJUST() { return 'adjust'; }
	get CHANGE_INDEX() { return 'changeIndex'; }

	// state changes

	get CHANGED() { return 'changed'; }

}

export default new ProgressEvent();
